import { createSlice } from "@reduxjs/toolkit";
import { Region } from "interfaces/demandas/demandasInterface";
import { JuzgadoInterface } from "interfaces/juzgadosConExpediente/juzgadosConExpedinte";

interface JuzgadoConExpedienteState {
  lstJuzgados: JuzgadoInterface[];
  filterJuzgados: JuzgadoInterface[];
  lstRegiones: Region[];
  juzgadoSelected: Partial<JuzgadoInterface>;
}

const initialState: JuzgadoConExpedienteState = {
  lstJuzgados: [],
  filterJuzgados: [],
  lstRegiones: [],
  juzgadoSelected: {},
};

export const juzgadoConExpedienteSlice = createSlice({
  name: "juzgadoConExpediente",
  initialState,
  reducers: {
    onLoadJuzgados: (state, { payload }) => {
      state.lstJuzgados = payload;
      state.filterJuzgados = payload;
    },
    onLoadJuzgadosFilter: (state, { payload }) => {
      state.filterJuzgados = payload;
    },
    onLoadRegiones: (state, { payload }) => {
      state.lstRegiones = payload;
    },
    onJuzgadoSelected: (state, { payload }) => {
      state.juzgadoSelected = payload;
    },
    onResetState: (state) => {
      state.lstJuzgados = [];
      state.filterJuzgados = [];
      state.lstRegiones = [];
      state.juzgadoSelected = {};
    },
  },
});

export const {
  onLoadJuzgados,
  onLoadJuzgadosFilter,
  onLoadRegiones,
  onJuzgadoSelected,
  onResetState
} = juzgadoConExpedienteSlice.actions;
